import { render, staticRenderFns } from "./mapbg.vue?vue&type=template&id=2f13d278&scoped=true"
import script from "./mapbg.vue?vue&type=script&lang=js"
export * from "./mapbg.vue?vue&type=script&lang=js"
import style0 from "./mapbg.vue?vue&type=style&index=0&id=2f13d278&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13d278",
  null
  
)

export default component.exports